export const testInputValues = [
  {
    id: 1,
    name: "AKT",
  },
  {
    id: 2,
    name: "AKT2",
  },
  {
    id: 3,
    name: "AKT3",
  },
  {
    id: 4,
    name: "AKT4",
  },
];

export const lessonInputValues = [
  {
    id: 1,
    name: "Ders seçiniz",
  },
  {
    id: 2,
    name: "Ders seçiniz",
  },
  {
    id: 3,
    name: "Ders seçiniz",
  },
  {
    id: 4,
    name: "Ders seçiniz",
  },
];

export const subjectInputValues = [
  {
    id: 1,
    name: "Konu seçiniz",
  },
  {
    id: 2,
    name: "Konu seçiniz",
  },
  {
    id: 3,
    name: "Konu seçiniz",
  },
  {
    id: 4,
    name: "Konu seçiniz",
  },
];
